import React from 'react';
import Input from '../../../components/Inputs/Input/Input';
import formStyles from '../../../components/Form/form.module.css';
import { textStyles } from '../../../constants/textStyles';
import { originLabel } from '../../../constants/carOrigin';
import { ENGINE_TYPE_OPTIONS } from '../../Car/NewCar/carInfoInputs';
import { colorName } from '../../Car/NewCar/vinSearch';
import formatDate from '../../../utils/formatDate';
import formatNumber from '../../../utils/formatNumber';

const grid = { display: 'grid', gap: 20, gridTemplateColumns: '1fr 1fr', marginTop: 16 };

const engineLabel = (car) => {
  const code = car?.engineType;
  return ENGINE_TYPE_OPTIONS.find((option) => option.value === code)?.label || car?.complectation?.engine?.title || '';
};

const transmissionLabel = (car) => {
  const value = car?.transmission;
  if (!value) return '';
  return typeof value === 'string' ? value : value.title || value.name || '';
};

// Ð¢Ðµ Ð¶Ðµ Ð¿Ð¾Ð»Ñ, ÑÑÐ¾ Ð² ÑÐ¾ÑÐ¼Ðµ Ð½Ð¾Ð²Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ, â Ð¿Ð¾ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ðµ Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ°.
export const selectedCarRows = (car) => [
  ['ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ', originLabel(car?.originCarId, true) || ''],
  ['ÐÐ°ÑÐºÐ°', car?.mark],
  ['ÐÐ¾Ð´ÐµÐ»Ñ', car?.model],
  ['ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°', car?.issueYear],
  ['VIN', car?.vin],
  ['Ð¦Ð²ÐµÑ ÐºÑÐ·Ð¾Ð²Ð°', colorName(car?.color)],
  ['Ð¦ÐµÐ½Ð°', car?.price ? `${formatNumber(car.price)} â¸` : ''],
  ['ÐÐ¾Ð¼ÐµÑ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÐ°', car?.texNumber],
  ['ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸ ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÐ°', car?.texDate ? formatDate(car.texDate) : ''],
  ['ÐÐ±ÑÑÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ', car?.engine_volume],
  ['Ð¢Ð¸Ð¿ ÐºÐ¾ÑÐ¾Ð±ÐºÐ¸ Ð¿ÐµÑÐµÐ´Ð°Ñ', transmissionLabel(car)],
  ['ÐÑÐ¾Ð±ÐµÐ³, ÐºÐ¼', car?.mileage],
  ['Ð¢Ð¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ', engineLabel(car)],
];

const SelectedCarFields = ({ car }) => (
  <div className={formStyles.borderWrapper}>
    <p style={textStyles.formTitle}>ÐÐ°Ð½Ð½ÑÐµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ</p>
    <div style={grid}>
      {selectedCarRows(car).map(([label, value]) => (
        <Input key={label} label={label} value={value ?? ''} onChange={() => {}} disabled placeholder="â" />
      ))}
    </div>
  </div>
);

export default SelectedCarFields;
